const Rapports = () => import('@/components/rapports/Rapports.vue')

export default [
  {
    path: '/rapports',
    name: 'Rapports',
    component: Rapports
  }
]
